<div class="frozen-screen" *ngIf="rpcInProgress || loading"></div>
<div class="render-container">
</div>

<div class="error" *ngIf="error">
	Unable to load microsite
</div>
